import { render } from "./Grid.vue?vue&type=template&id=924e9a86&scoped=true&ts=true"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"

import "./Grid.vue?vue&type=style&index=0&id=924e9a86&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924e9a86"]])

export default __exports__